module.exports = __webpack_public_path__ + "static/media/gd.f68f1bcc.svg";